module.exports = __webpack_public_path__ + "static/sm_img04_m@2x-0a137eae85ab560fd8ccfad82aad1aba.jpg";